<template>
<!-- 搜索页 -->
  <div class="page" v-cloak>
    <!-- 顶部搜索 -->
     <form action="/">
        <van-search
          v-model="searchValue"
          autofocus
          clearable
          show-action
          placeholder="请输入商品关键词"
          @search="onSearch"
          @cancel="onCancel"
        />
    </form>

    <div class="header-value" v-if="isBlock == false" @click="goSearchInput(searchValue)">
      {{searchValue}}
    </div>

    <!-- 历史搜索 -->
    <div class="history-block" v-if="isBlock && historyList.length > 0">
      <div class="tips-block">
        <span class="tips-title">历史搜索</span>
        <div class="tips-icon" @click="deleteAll"><van-icon  name="delete-o" /></div>
      </div>
      <!-- 模块 -->
      <div class="lable-block">
         <van-tag class="mlt" v-for="(item, index) in historyList" :key="index" closeable size="large" color="#F9F9F9" text-color="#999999" type="primary" @close="close(index,item)"  @click="goSearchInput(item)">{{item}}</van-tag>
      </div>
    </div>

    <!-- 热门搜索 -->
    <div class="hot-block" v-if="isBlock">
      <div class="tips-block">
        <span class="tips-title">热门搜索</span>
        <div class="tips-icon" @click="onHot"><van-icon v-if="isHot" name="eye-o" /> <van-icon v-else name="closed-eye" /></div>
      </div>
       <!-- 模块  -->
      <div class="lable-block"  v-show="isHot" >
         <van-tag class="mlt" v-for="(item, index) in hotList" :key="index" size="large" color="#F9F9F9" text-color="#999999" type="primary" @click="goSearchInput(item)">{{item}}</van-tag>
          
      </div>
  
    </div>



  </div>
</template>

<script type="text/babel">
let fromparams = '';
export default {
  name: 'Search',
  components: {},
  props: {},
  data() {
    return {
       searchValue: '', // 搜索框数据
       isBlock:true, //标签模块显示隐藏
       isHot:true, // 热门显示隐藏
       historyList:[], //历史
       hotList:['耳机','包','礼盒','家居','毛巾','海鲜','饮料','洗护','配件','水杯','水壶',], //热门
      aa:{}
    }
  },
  watch: {
    searchValue(newV,oldV){
      if(newV.length > 0){
        this.isBlock = false;
      }else{
         this.isBlock = true;
      }
    },
    aa:{
      handler(newValue, oldValue){
          // console.log(newValue,oldValue)
      },
       deep:true // 深度监听表单
    },
  },
  created() {},
  mounted() {
    this.historyList = Lockr.get('historyList') || [];
  },
  //vue对象中
  beforeRouteEnter (to, from, next){
    // console.log(to,'to')
    // console.log(from,'from')
      if(from.query){
        fromparams = from.query.key;
      }
      next();
  },
  beforeMount (){
    if(fromparams){
        //将url上带回的参数赋值给vue中的data对象,从而实现条件的带回
        // console.log(fromparams)
        this.searchValue  = fromparams;
    }
  },
  methods: {
    close(ind,iem){
      // console.log(ind,iem)
      Lockr.srem("historyList",iem);
      this.historyList.splice(ind, 1);
    },
    // 删除历史搜索
    deleteAll(){
      this.$dialog.confirm({
        message: '是否删除全部历史搜索？',
        confirmButtonColor:'#ff5000',
        cancelButtonColor:'#454F63'
      })
        .then(() => {
          // on confirm
          Lockr.rm('historyList');
          this.historyList = []
        })
        .catch(() => {
          // on cancel
        });
    },
    // 热门搜索显示隐藏
    onHot(){
      this.isHot = !this.isHot;
    },
    // 点击标签
    goSearchInput(e){
      // console.log(e)
      this.searchValue = e;
      Lockr.sadd("historyList", e); // 往缓存里添加
      this.$router.push({ name:'search-list',  query:{key:e}});
    },
    onSearch(val) {
      // this.$toast(val);
      Lockr.sadd("historyList", val); // 往缓存里添加
      this.$router.push({ name:'search-list',  query:{key:val}});
    },
    onCancel() {
      this.$toast('取消');
      this.$router.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>
.page{
  height: 100%;
  width: 100%;
  background-color: #f9f9f9;

  // 模块标题
  .tips-block{
    width: 100%;
    height: 36px;
    padding: 0 18px;
    // background-color: #eee;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tips-title{
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 27px;
      color: #454F63;
      letter-spacing: 2px;
    }
    .tips-icon{
      width: 15px;
      height: 15px;
      font-size: 15px;
      // background-color: palegreen;
    }
  }
  .tips-block::after {
      content: "";
      position: absolute;
      width: 3px;
      height: 13px;
      left: 0;
      top: 11px;
      background: #ff5000;
      z-index: 1;
      border-radius: 0 5px 5px 0;
    }
    // lable模块
    .lable-block{
      width: 100%;
      padding: 0 15px 15px 0;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      flex-wrap:wrap;
      position: relative;
      .mlt{
        margin: 15px 0 0 15px;
      }
    }
 
  // 历史搜索
  .history-block{
    // background-color: peachpuff;
  }
  // 
  .hot-block{
    // background-color: paleturquoise;
  }
  .header-value{
    text-align: left;
    margin: 0 18px;
    padding: 10px 5px;
    // background-color: peachpuff;
    border-bottom: 1px solid #CCCCCC;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 21px;
    color: #2A2E43;
    letter-spacing: 1px;
  }
}
</style>
